import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=280c5619&scoped=true&lang=pug"
import script from "./CalendarMonth.vue?vue&type=script&lang=js"
export * from "./CalendarMonth.vue?vue&type=script&lang=js"
import style0 from "./CalendarMonth.vue?vue&type=style&index=0&id=280c5619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c5619",
  null
  
)

export default component.exports